import { render, staticRenderFns } from "./SectionsNavigation.vue?vue&type=template&id=d8797a0c&scoped=true&"
import script from "./SectionsNavigation.vue?vue&type=script&lang=js&"
export * from "./SectionsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SectionsNavigation.vue?vue&type=style&index=0&id=d8797a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8797a0c",
  null
  
)

export default component.exports